import axios from 'axios';

// Настройка клиента для общения с твоим сервером
const api = axios.create({
    baseURL: 'https://api.fizika.app/api', // Твой боевой сервер
    headers: {
        'Content-Type': 'application/json',
        'iC9k2w': 'KWtv6v' // <--- СЕКРЕТНЫЙ КЛЮЧ (из твоего бэкенда)
    },
});

export const physicsApi = {
    // Получаем список формул. По умолчанию берем 'ru', но можно передать 'en'
    getFormulaList: (locale = 'ru') => api.get(`/formula/list/${locale}`),

    // Получаем список терминов (Словарь)
    getTermsList: (locale = 'ru') => api.get(`/terms/list/${locale}`),
};

export default api;